import type { ReactElement } from 'react'

import VideoPreview from '../VideoPreview'

import './styles.scss'

interface Props {
  mimeType?: string
  onClick?: () => void
  src: string
  useVideoPlayer?: boolean
}

const FilePreviewImage = ({ mimeType, onClick, src, useVideoPlayer = false }: Props): ReactElement => {
  const prefix = mimeType?.split('/')[0]

  switch (prefix) {
    case 'image':
      return (
        <div className="asset-preview-image">
          <img alt="" onClick={onClick} role="presentation" src={src} />
        </div>
      )
    case 'video':
      return (
        <div className="asset-preview-video-wrapper" onClick={onClick}>
          {useVideoPlayer ? <VideoPreview url={src} /> : <video className="asset-preview-image" src={src} />}
        </div>
      )
    case 'audio':
      return (
        <div className="asset-preview-image default" onClick={onClick}>
          <span className="material-symbols-outlined">music_note</span>
        </div>
      )
    default:
      return (
        <div className="asset-preview-image default" onClick={onClick}>
          <span className="material-symbols-outlined">draft</span>
        </div>
      )
  }
}

export default FilePreviewImage
